<div class="full-sheet" [@sheetUp]="animationState">
  <div>
    <div *ngIf="isiOSMobile && isOnline && isLoggedIn" class="card-details__add-to-wallet">
      <a (click)="addPassbookToWallet()" [class.button--disabled]="passbookLoading"><img src="assets/images/button-wallet.svg" /></a>
    </div>
    <air-my-card *ngIf="isLoggedIn"></air-my-card>
    <div *ngIf="!isLoggedIn" class="full-sheet__logo"><div class="logo--air-miles"></div></div>
  </div>
  <div>
    <a (click)="checkConnection(true)" [airButtonLoading]="isCheckingConnection" class="button button--primary button--full-width">
      <span>{{ (isOnline && !isInMaintenance ? "general.label.close" : "general.label.retry_connection") | translate }}</span>
    </a>
  </div>
</div>
